import React from "react";

export default function Header() {
	return (
		<header className="app-header">
			<h1 className="app-title">
				<a href="/">We've all faced rejection.</a>
			</h1>
		</header>
	);
}
